<template>
  <div class="costSummaryTable">
     <div class="content-container">
      <div class="titieMian">
        <div class="title-container">费用分摊汇总表</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>时间：</span>
            <el-date-picker
              size="small"
              v-model="startDate"
              type="month"
              :clearable="false"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              >
            </el-date-picker>
          </div>
          <div class="select-container-box" style="padding:0 5px">
            <span>至</span>
          </div>
          <div class="select-container-box" style="padding:0 1px">
            <el-date-picker
              size="small"
              v-model="endDate"
              type="month"
              :clearable="false"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
             >
            </el-date-picker>
          </div>
          <div class="select-container-box total">
            <span>基地：</span>
            <el-select  multiple placeholder="请选择" size="small" v-model="baseId" @change="baseChange">
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="(item, index) in baseList" 
                :key="index" 
                :label="item.value" 
                :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box total">
            <span>汇总条件：</span>
            <el-select v-model="groupBy" multiple size="middle"  placeholder="请选择" @change="groupByChange">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box"> 
            <el-button size="small"  type="info" plain  class="query" @click="search">查询</el-button>
          </div>
        </div>
      </div>
      <div class="table-container">
         <!-- 表头 -->
        <table class="table-package">
          <thead class="table-thead">
            <tr>
              <th>基地</th>
              <th v-if="showCol(1)">塘口</th>
              <th v-if="showCol(2)">费用类目</th>
              <th v-if="showCol(4)">费用名称</th>
              <th>分摊金额</th>
            </tr>
          </thead>
        </table>
         <!-- 表体 -->
        <div class="scroll-box3">
          <table class="table-package">
            <tbody class="table-tbodys" v-if=" this.tableData4.length !== 0">
              <tr v-for="(item,index) in tableData4" :key="index"  >
                <td :rowspan="item.fishBaseIdspan" :class="{hidden: item.fishBaseIddis}">{{item.fishBaseName}}</td>
                <td v-if="showCol(1)" :rowspan="item.pondInfospan" :class="{hidden: item.pondInfodis}">{{item.fishPondName}}</td>
                <td v-if="showCol(2)" :rowspan="item.categoryInfospan" :class="{hidden: item.categoryInfodis}">{{item.costCategoryName}}</td> 
                <td v-if="showCol(4)">{{item.costTypeName}}</td> 
                <td>{{item.amount|decimal}}</td> 
              </tr>
            </tbody>
            <tbody class="table-tbodys" v-if=" this.tableData4.length === 0">
              <tr>
                <td colspan="5">该时间段暂无数据</td>
              </tr>
            </tbody>
            <tbody class="table-tbodys">
              <tr>
                <td>合计</td>
                <td v-if="showCol(1)">--</td>
                <td v-if="showCol(2)">--</td>
                <td v-if="showCol(4)">--</td> 
                <td>{{total}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../store";
import checkPermission from "../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  mixins: [mixins],
  name: "costSummaryTable",
  data() {
    return {
      startDate: "",
      endDate: "",
      options: [
        {
          value: "1",
          label: "塘口"
        },
        {
          value: "2",
          label: "费用类目"
        },
        {
          value: "4",
          label: "费用名称"
        }
      ],
      order: {
        date: "",
        groupBy: 7, //汇总方式-默认全选
        baseId: [], //基地
        Way: ""
      },
      baseId: [], //基地
      groupIndex: 0,
      groupBy: ["1", "2", "4"], //汇总方式
      baseList: [],
      allBaseList: [],
      wayList: [],
      spanArr: [],
      list: [],
      tableData4: []
    };
  },
  //默认时间
  created() {
    const start = new Date();
    start.setMonth(start.getMonth() - 1);
    start.setDate(1);
    this.startDate = this.$timeformatDay(start);
    this.endDate = this.$timeformatDay(new Date());
    console.log(this.startDate, this.endDate);
  },
  watch: {
    baseId: function(val, oldval) {
      if (val.indexOf("") != -1 && oldval.indexOf("") == -1 && val.length > 1) {
        //如果新的选择里有勾选了选择所有选择所有 则 只直线勾选所有整个选项
        this.baseId = [""];
      } else if (
        (this.index =
          val.indexOf("") != -1 && oldval.indexOf("") != -1 && val.length > 1)
      ) {
        //如果操作前有勾选了选择所有且当前也选中了勾选所有且勾选数量大于1  则移除掉勾选所有
        this.baseId.splice(val.indexOf(""), 1);
      }
    },
    groupBy: function(val, oldVal) {
      if (val.length < 1) {
        this.$message({
          message: "必须选中一项",
          type: "error"
        });
        this.groupBy = oldVal;
      }
    }
  },
  methods: {
    ...mapActions(modules.base, {
      getBaseList: "getBaseList" //基地
    }),
    ...mapActions(modules.expense, {
      getCostAllocationReport: "getCostAllocationReport"
    }),
    baseChange(e) {
      // this.order.baseId = e.join();
    },
    groupByChange() {
      this.search();
    },
    //汇总方式必须选一个
    showCol(index) {
      return this.groupBy.some(item => {
        return item == index;
      });
    },
    //动态合并表格
    combine(list, field, assistFields = []) {
      var k = 0;
      while (k < list.length) {
        list[k][field + "span"] = 1;
        list[k][field + "dis"] = false;
        for (var i = k + 1; i <= list.length - 1; i++) {
          let isEqual =
            list[k][field] == list[i][field] && list[k][field] != "";

          assistFields.forEach(item => {
            isEqual =
              isEqual &&
              (list[k][item] == list[i][item] && list[k][item] != "");
          });

          if (isEqual) {
            list[k][field + "span"]++;
            list[k][field + "dis"] = false;
            list[i][field + "span"] = 1;
            list[i][field + "dis"] = true;
          } else {
            break;
          }
        }
        k = i;
      }
      return list;
    },
    //查询
    async search() {
      let obj = {
        baseId: this.baseId.join(),
        startDate: this.startDate,
        endDate: this.endDate,
        groupBy: this.groupBy.reduce((now, next) => Number(now) + Number(next))
      };
      console.log(obj);
      try {
        let list = await this.getCostAllocationReport(obj);
        if(list && list.length){
         list = list.map((item) =>{ 
          item.pondInfo = `${item.fishBaseId}_${item.fishPondId}`;
          item.categoryInfo = `${item.fishBaseId}_${item.fishPondId}_${item.costCategoryName}`;
          return item;
         })
        }

        this.tableData4 = this.combine(list,"fishBaseId");
        this.tableData4 = this.combine(this.tableData4, "pondInfo");
        this.tableData4 = this.combine(this.tableData4, "categoryInfo");
          console.log(89787, this.tableData4);
        this.order.groupBy = obj.groupBy;
      } catch (e) {
        // Message.error(e.response.data);
        console.log(e);
      }
    }
  },
  computed: {
    total() {
      let total = 0
      this.tableData4.forEach( item => {
        total += item.amount
      })
      return total.toFixed(2)
    }
  },
  async mounted() {
    this.baseList = await this.getBaseList();
    this.baseId = [""];
    this.search();
  }
};
</script>
<style lang="stylus" >
  .costSummaryTable
    .total{
      .el-select__tags{
        top:65%;
        height: 30px;
        overflow: auto;
      }
      .el-input__suffix{
        top:6px;
      }
      .is-focus .el-input__suffix {
        top:0px;
      }
      
    }
    .scroll-box3
      width: 100%;
      max-height:calc(100vh - 288px);
      overflow-y:auto;
      overflow-x:hidden;
    .table-package
      width 100%
      border-collapse collapse
      // border 1px #ddd solid
      border:none;
    .table-thead
      border-top: 2px solid rgb(51,137,255);
      
      >tr th
        width:294px;
        text-align center
        height: 50px;
        font-size: 14px;
        line-height: 50px;
        color #666;
        font-weight bold
        border: 1px solid #e0e0e0;
        border-bottom: 1px solid rgb(51,137,255);
        background-color: #f7f7f7;
    .table-tbodys
      :hover
        background:#c3e3ff;
      tr
        text-align center
        height 37px
        line-height 37px
        border: 1px solid #ddd;
        border:none;
        background-color #fff
      td
        width:294px;
        border 1px solid #e0e0e0
        color: #666;
        border-top:none;
        vertical-align:middle;
      .total{
        .el-select__tags{
          top:65%;
          height: 30px;
          overflow: auto;
        }
        .el-input__suffix{
          top:6px;
        }
        .is-focus .el-input__suffix {
          top:0px;
        }
      }
      .hidden{
        display: none
      }
    .table-container
      .el-table::before
        width:100%!important
        border-bottom:0.5px solid #DDDDDD!important
      .el-table .el-table__body tbody td
        border-bottom 1px solid #DDD!important;
      .el-table .el-table__row:nth-of-type(even)
        background #fff !important;
    .select-container-box:nth-child(4){
      position relative
      .el-input{
        width:270px;
        .el-input__inner{
          height:34px!important;
        }
        .el-input__suffix {
          right: 5px;
          top: 1px;
        }
      }
      .el-select__tags {
        position: absolute;
        z-index: 1;
        top: 64%;
      }
    }
    .select-container-box:nth-child(5){
      position relative
      .el-input{
        width:270px;
        .el-input__inner{
          height:34px!important;
        }
        .el-input__suffix {
          right: 5px;
          top: 5px;
        }
      }
      .el-select__tags {
        position: absolute;
        z-index: 1;
        top: 64%;
      }
    }
     

</style>
